/**
 * @generated SignedSource<<f99695fe9b3fb209f7d0a554a51bd0aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bidId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessIdentityDocumentCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBusinessIdentityDocTPayload",
        "kind": "LinkedField",
        "name": "createBusinessIdentityDocT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessIdentityDocT",
            "kind": "LinkedField",
            "name": "businessIdentityDocT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessIdentityDocumentCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBusinessIdentityDocTPayload",
        "kind": "LinkedField",
        "name": "createBusinessIdentityDocT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessIdentityDocT",
            "kind": "LinkedField",
            "name": "businessIdentityDocT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "17f1eddfcdaf6ffa93710914dfd6e65f",
    "id": null,
    "metadata": {},
    "name": "BusinessIdentityDocumentCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BusinessIdentityDocumentCreateMutation(\n  $input: CreateBusinessIdentityDocTInput!\n) {\n  createBusinessIdentityDocT(input: $input) {\n    businessIdentityDocT {\n      bidId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1f89c1f38625651294815ad61e7a2131";

module.exports = node;
